export default "__VITE_ASSET__BRLFco3I__"